import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Card, CardContent, Typography, Avatar, Box } from "@mui/material";
const testimonials = [
    {
      id: 1,
      name: "Mrs.Pallavi Kedia",
      image: "https://vedantaiasacademy.co.in/image/director_mrs._pallavi_kedia.webp",  // Replace with actual image
      text: "जो व्यक्ति अपने कदमों की काबिलियत पर विश्वास रखते हैं, वही सफलता की मंजिल तक पहुंचते हैं।" ,
      position: "Staff",
    },
    {
      id: 2,
      name: "Mr. Ravi Ranjan",
      image: "https://vedantaiasacademy.co.in/image/ravi.png",
      text:"Wasting time is stupidity utilize every second and live with dignity.",
      position: "Staff",
    },
    {
      id: 3,
      name: "Mrs.Alisha ",
      image: "https://via.placeholder.com/100",
      text: "यह सच है कि आबाज ऊँची हो तो कुछ लोग सुनते है, मगर बात ऊँची हो तो बहुत सारे लोग सुनते हैं!",
      position: "Staff",
    },
    {
      id: 4,
      name: "Mr.Rajneesh ",
      image: "https://via.placeholder.com/100",
      text: "अगर जीवन में सफल होना है तो कभी भी संकोच न करें, साहस के साथ आगे बढ़ें।",
      position: "Staff",
    },
  ];
  
  const Htestimonials = () => {
    const settings = {
      dots: true,          // Show navigation dots
      infinite: true,      // Infinite scrolling
      speed: 500,         // Transition speed
      slidesToShow: 2,    // Show two slides at a time
      slidesToScroll: 2,  // Scroll two slides at a time
      autoplay: true,     // Auto-play testimonials
      autoplaySpeed: 3000, // Change testimonial every 3 seconds
      responsive: [
        {
          breakpoint: 768, // On smaller screens (tablets, phones)
          settings: {
            slidesToShow: 1,  // Show only one per row
            slidesToScroll: 1,
          },
        },
      ],
    };
  
    return (
      <Box sx={{ width: "80%", margin: "auto" }}>
        <Typography variant="h4" align="center" fontWeight={700} mb={3}>
          What Our Staff Say
        </Typography>
        <Slider {...settings}>
          {testimonials.map((testimonial) => (
            <Box key={testimonial.id} sx={{ px: 2 }}> {/* Added spacing between cards */}
              <Card sx={{ textAlign: "center", p: 2,background: "linear-gradient(350deg,#edf5ff 0%, #edf5ff 0%, rgba(255, 250, 250, 1) 100%)",boxShadow:" rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px" }}>
                <Avatar
                  src={testimonial.image}
                  sx={{ width: 80, height: 80, margin: "auto", mb: 2 }}
                />
                <CardContent>
                  <Typography variant="body1" sx={{ fontStyle: "italic", mb: 2 ,fontWeight: 800}}>
                    "{testimonial.text}"
                  </Typography>
                  <Typography variant="h6" fontWeight={600}>
                    {testimonial.name}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {testimonial.position}
                  </Typography>
                </CardContent>
              </Card>
            </Box>
          ))}
        </Slider>
      </Box>
    );
  };
  
  export default Htestimonials;
  